import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.memory');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-memory',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.admin.memory/view.scss */
.memory-upload-progress-active {
  position: relative;
  overflow: hidden;
  animation: memory-upload-pulse 1.2s ease-in-out infinite;
}

.memory-upload-progress-active::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.45) 50%, rgba(255, 255, 255, 0) 100%);
  animation: memory-upload-shimmer 1.1s linear infinite;
}

@keyframes memory-upload-pulse {
  0%, 100% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.18);
  }
}
@keyframes memory-upload-shimmer {
  100% {
    transform: translateX(100%);
  }
}`],
})
export class PortalAdminMemoryComponent implements OnInit, OnDestroy {
    public status: any = {
        index: {},
        name_index: {},
        service: {},
        build: {},
        rebuild: {},
        upload: {},
        memory: {},
        runtime: {},
    };
    public loading: boolean = false;
    public action: string = '';
    public error: string = '';
    public message: string = '';
    public showRebuildConfirm: boolean = false;
    public autoRefreshEnabled: boolean = true;
    public logLines: string[] = [];
    public logText: string = '';
    public serviceDiagnostics: any = {};

    public serviceState: string = 'unknown';
    public servicePid: any = '';
    public serviceProcessRunning: boolean = false;
    public serviceUrl: string = '';
    public serviceScript: string = '';
    public serviceVersion: string = '';
    public serviceLoadSeconds: any = 0;

    public indexExists: boolean = false;
    public indexSize: any = 0;
    public indexModifiedAt: string = '';
    public indexPath: string = '';
    public nameIndexExists: boolean = false;
    public nameIndexSize: any = 0;
    public nameIndexModifiedAt: string = '';
    public nameIndexPath: string = '';

    public buildState: string = 'idle';
    public buildPid: any = '';
    public buildChildPid: any = '';
    public buildRunning: boolean = false;
    public buildProgressPath: string = '';
    public buildLogPath: string = '';
    public buildCurrentCommand: string = '';
    public buildLastPhase: string = '';
    public buildPercentValue: any = null;

    public rebuildState: string = 'idle';
    public rebuildRunning: boolean = false;
    public rebuildVerified: boolean = false;
    public rebuildPid: any = '';
    public rebuildPhase: string = '';
    public rebuildStartedAt: string = '';
    public rebuildFinishedAt: string = '';
    public rebuildElapsedSeconds: any = 0;
    public rebuildProgressValue: any = null;
    public rebuildEtaSeconds: any = 0;
    public rebuildError: string = '';
    public rebuildIndexes: any = {};
    public rebuildService: any = {};
    public rebuildVerification: any = {};

    public uploadState: string = 'stopped';
    public uploadActive: boolean = false;
    public uploadProgressValue: any = null;
    public uploadElapsedSeconds: any = 0;
    public uploadEstimatedSeconds: any = 0;
    public uploadRemainingSeconds: any = 0;
    public uploadReadBytes: any = 0;
    public uploadTotalBytes: any = 0;
    public uploadProgressPath: string = '';
    public uploadProgressSource: string = '';
    public uploadProgressSupported: boolean = false;
    public uploadMessage: string = '';
    public uploadStartedAt: string = '';

    public systemMemory: any = {};
    public serviceMemory: any = {};
    public buildMemory: any = {};
    public runtimeLimitMode: string = '';

    public autoRefreshButtonClass: string = '';
    public autoRefreshDotClass: string = '';
    public autoRefreshPingVisible: boolean = false;
    public autoRefreshLabel: string = '';
    public refreshDisabled: boolean = false;
    public refreshIconClass: string = '';
    public uploadDisabled: boolean = false;
    public uploadIconClass: string = '';
    public uploadButtonLabel: string = '';

    public uploadStateText: string = '-';
    public uploadStateBadgeClass: string = '';
    public uploadHeaderIconClass: string = '';
    public uploadSourceText: string = '-';
    public uploadMessageText: string = '';
    public uploadProgressText: string = '-';
    public uploadProgressWidth: number = 0;
    public uploadProgressBarClass: string = '';
    public uploadElapsedText: string = '-';
    public uploadEstimatedText: string = '-';
    public uploadRemainingText: string = '-';
    public uploadReadSizeText: string = '0 B';
    public uploadTotalSizeText: string = '0 B';
    public uploadPidText: string = '-';
    public uploadRssText: string = '0 B';
    public uploadProgressPathText: string = '-';

    public diagnosticsVisible: boolean = false;
    public diagnosticMessageText: string = '';
    public diagnosticHealthUrlText: string = '-';
    public diagnosticPidFileText: string = '-';
    public diagnosticPidSourceText: string = '-';
    public diagnosticVersionText: string = '-';
    public diagnosticScriptPathText: string = '-';
    public diagnosticIndexPathText: string = '-';

    public serviceStateText: string = '확인 필요';
    public serviceStateBadgeClass: string = '';
    public servicePidText: string = '-';
    public indexStateText: string = '없음';
    public indexStateBadgeClass: string = '';
    public indexSizeText: string = '0 B';
    public indexModifiedText: string = '-';
    public nameIndexStateText: string = '없음';
    public nameIndexStateBadgeClass: string = '';
    public nameIndexSizeText: string = '0 B';
    public nameIndexModifiedText: string = '-';
    public buildStateText: string = '대기';
    public buildStateBadgeClass: string = '';
    public buildPidText: string = '-';
    public buildPhaseText: string = '-';

    public rebuildVisible: boolean = false;
    public rebuildStateText: string = '이력 없음';
    public rebuildStateBadgeClass: string = '';
    public rebuildPhaseText: string = '-';
    public rebuildProgressText: string = '-';
    public rebuildProgressWidth: number = 0;
    public rebuildProgressBarClass: string = '';
    public rebuildStartedText: string = '-';
    public rebuildFinishedText: string = '-';
    public rebuildElapsedText: string = '-';
    public rebuildEtaText: string = '-';
    public rebuildPidText: string = '-';
    public rebuildVerificationText: string = '검증 대기';
    public rebuildVerificationClass: string = '';
    public rebuildKeywordSizeText: string = '0 B';
    public rebuildNameSizeText: string = '0 B';
    public rebuildResearcherCountText: string = '0';
    public rebuildDocumentCountText: string = '0';
    public rebuildTermCountText: string = '0';
    public rebuildSchemaText: string = '-';
    public rebuildNameVerifyText: string = '-';
    public rebuildKeywordVerifyText: string = '-';
    public rebuildExpandedVerifyText: string = '-';

    public systemMemoryPercentText: string = '0%';
    public systemMemoryUsedText: string = '0 B';
    public systemMemoryTotalText: string = '0 B';
    public systemMemoryAvailableText: string = '0 B';
    public systemMemoryBarClass: string = '';
    public systemMemoryBarWidth: number = 0;
    public serviceMemoryPidText: string = '-';
    public serviceMemoryRssText: string = '0 B';
    public serviceMemoryVmsText: string = '0 B';
    public serviceMemoryHwmText: string = '0 B';
    public serviceMemoryPercentText: string = '0%';
    public serviceMemoryBarWidth: number = 0;
    public buildMemoryPidText: string = '-';
    public buildMemoryRssText: string = '0 B';
    public buildMemoryVmsText: string = '0 B';
    public buildMemoryPercentText: string = '0%';
    public buildMemoryBarWidth: number = 0;
    public runtimeLimitText: string = '-';

    public serviceUrlText: string = '-';
    public serviceScriptText: string = '-';
    public indexPathText: string = '-';
    public nameIndexPathText: string = '-';
    public serviceInfoVisible: boolean = false;
    public serviceVersionText: string = '-';
    public serviceLoadSecondsText: string = '0';
    public restartDisabled: boolean = true;
    public restartIconClass: string = '';
    public stopDisabled: boolean = true;
    public hasLogLines: boolean = false;
    public hasNoLogLines: boolean = true;

    private refreshTimer: any = null;
    private clockTimer: any = null;
    private uploadClockSyncedAtMs: number = 0;
    private uploadClockBaseElapsedSeconds: number = 0;
    private uploadClockBaseRemainingSeconds: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStatus();
        this.refreshTimer = setInterval(async () => {
            if (this.shouldAutoRefresh()) {
                await this.loadStatus(false);
            }
        }, 2000);
        this.clockTimer = setInterval(() => {
            this.tickUploadClock();
        }, 1000);
    }

    public ngOnDestroy() {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
        if (this.clockTimer) {
            clearInterval(this.clockTimer);
            this.clockTimer = null;
        }
    }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    private async readJson(resp: Response) {
        const text = await resp.text();
        let json: any = null;
        try {
            json = text ? JSON.parse(text) : null;
        } catch (e) {
            throw new Error(`응답을 해석하지 못했습니다. (${resp.status})`);
        }
        if (!resp.ok) {
            const data = json && json.data ? json.data : {};
            const message = data.message || (json && json.message) || `요청 실패 (${resp.status})`;
            throw new Error(message);
        }
        return json;
    }

    private async postForm(fn: string, params: Record<string, any> = {}) {
        const body = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => body.set(key, String(value === null || value === undefined ? '' : value)));
        const resp = await fetch(this.apiUrl(fn), {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
        });
        return await this.readJson(resp);
    }

    private statusPayload(json: any) {
        const data = json && json.data ? json.data : {};
        const nested = data && data.data ? data.data : null;
        if (nested && (nested.index || nested.service || nested.build || nested.upload || nested.memory)) {
            return nested;
        }
        return data;
    }

    private applyStatus(data: any) {
        const nested = data && data.data ? data.data : null;
        const safeData = nested && (nested.index || nested.service || nested.build || nested.upload || nested.memory)
            ? nested
            : (data || {});
        const index = safeData.index || {};
        const nameIndex = safeData.name_index || {};
        const service = safeData.service || {};
        const health = service.health || {};
        const build = safeData.build || {};
        const rebuild = safeData.rebuild || {};
        const upload = safeData.upload || {};
        const lastEvent = build.last_event || {};
        const memory = safeData.memory || {};
        const runtime = safeData.runtime || {};

        this.status = safeData;
        this.serviceDiagnostics = service.diagnostics || {};

        this.serviceState = service.state || 'unknown';
        this.servicePid = service.pid || '';
        this.serviceProcessRunning = !!service.process_running;
        this.serviceUrl = service.url || '';
        this.serviceScript = service.script || '';
        this.serviceVersion = health.version || service.version || '';
        this.serviceLoadSeconds = health.load_seconds || 0;

        this.indexExists = !!index.exists;
        this.indexSize = index.size || 0;
        this.indexModifiedAt = index.modified_at || '';
        this.indexPath = index.path || '';
        this.nameIndexExists = !!nameIndex.exists;
        this.nameIndexSize = nameIndex.size || 0;
        this.nameIndexModifiedAt = nameIndex.modified_at || '';
        this.nameIndexPath = nameIndex.path || '';

        this.buildState = build.state || 'idle';
        this.buildPid = build.pid || '';
        this.buildChildPid = build.child_pid || '';
        this.buildRunning = !!build.running || !!build.child_running || this.buildState === 'running';
        this.buildProgressPath = build.progress_path || '';
        this.buildLogPath = build.log_path || '';
        this.buildCurrentCommand = build.current_command || '';
        this.buildLastPhase = lastEvent.phase || '';
        this.buildPercentValue = this.normalizePercent(lastEvent.progress_percent);

        this.rebuildState = rebuild.state || 'idle';
        this.rebuildRunning = !!rebuild.running;
        this.rebuildVerified = !!rebuild.verified;
        this.rebuildPid = rebuild.pid || '';
        this.rebuildPhase = rebuild.phase || '';
        this.rebuildStartedAt = rebuild.started_at || '';
        this.rebuildFinishedAt = rebuild.finished_at || '';
        this.rebuildElapsedSeconds = rebuild.elapsed_seconds || 0;
        this.rebuildProgressValue = this.normalizePercent(rebuild.progress_percent);
        this.rebuildEtaSeconds = rebuild.eta_seconds || 0;
        this.rebuildError = rebuild.error || '';
        this.rebuildIndexes = rebuild.indexes || {};
        this.rebuildService = rebuild.service || {};
        this.rebuildVerification = rebuild.verification || {};

        this.uploadState = upload.state || 'stopped';
        this.uploadActive = !!upload.active;
        this.uploadProgressValue = this.normalizePercent(upload.progress_percent);
        this.uploadElapsedSeconds = upload.elapsed_seconds || 0;
        this.uploadEstimatedSeconds = upload.estimated_seconds || 0;
        this.uploadRemainingSeconds = upload.remaining_seconds || 0;
        this.uploadReadBytes = upload.read_bytes || 0;
        this.uploadTotalBytes = upload.total_bytes || 0;
        this.uploadProgressPath = upload.progress_path || '';
        this.uploadProgressSource = upload.progress_source || '';
        this.uploadProgressSupported = !!upload.progress_supported;
        this.uploadMessage = upload.message || upload.health_error || '';
        this.uploadStartedAt = upload.started_at || '';
        this.syncUploadClock();

        this.systemMemory = memory.system || {};
        this.serviceMemory = memory.service || {};
        this.buildMemory = memory.build || {};
        this.runtimeLimitMode = runtime.memory_limit_mode || '';

        const rebuildTail = String(rebuild.log_tail || '').trim();
        const uploadTail = String(upload.log_tail || '').trim();
        const buildTail = String(build.log_tail || '').trim();
        const tail = rebuildTail || uploadTail || buildTail;
        this.logLines = tail ? tail.split(/\r?\n/).slice(-10) : [];
        this.logText = this.logLines.join('\n');
        this.updateDisplayState();
    }

    private syncUploadClock() {
        this.uploadClockSyncedAtMs = Date.now();
        this.uploadClockBaseElapsedSeconds = Number(this.uploadElapsedSeconds || 0);
        this.uploadClockBaseRemainingSeconds = Number(this.uploadRemainingSeconds || 0);
    }

    private async tickUploadClock() {
        if (!this.uploadActive || !this.uploadClockSyncedAtMs) return;
        const deltaSeconds = Math.floor((Date.now() - this.uploadClockSyncedAtMs) / 1000);
        if (deltaSeconds <= 0) return;
        this.uploadElapsedSeconds = this.uploadClockBaseElapsedSeconds + deltaSeconds;
        if (this.uploadClockBaseRemainingSeconds > 0) {
            this.uploadRemainingSeconds = Math.max(this.uploadClockBaseRemainingSeconds - deltaSeconds, 0);
        } else if (Number(this.uploadEstimatedSeconds || 0) > 0) {
            this.uploadRemainingSeconds = Math.max(Number(this.uploadEstimatedSeconds || 0) - this.uploadElapsedSeconds, 0);
        }
        this.updateDisplayState();
        await this.service.render();
    }

    private text(value: any, fallback: string = '-') {
        const normalized = String(value === null || value === undefined ? '' : value).trim();
        return normalized || fallback;
    }

    private updateDisplayState() {
        this.autoRefreshPingVisible = this.autoRefreshEnabled;
        this.autoRefreshLabel = this.autoRefreshEnabled ? '실시간 ON' : '실시간 OFF';
        this.autoRefreshButtonClass = this.autoRefreshEnabled
            ? 'text-emerald-700 bg-emerald-50 border-emerald-100'
            : 'text-gray-600 bg-white border-gray-200 hover:bg-gray-50';
        this.autoRefreshDotClass = this.autoRefreshEnabled ? 'bg-emerald-500' : 'bg-gray-300';
        this.refreshDisabled = this.loading || !!this.action;
        this.refreshIconClass = this.loading ? 'w-4 h-4 animate-spin' : 'w-4 h-4';
        this.uploadDisabled = !!this.action || this.uploadActive || this.isBuildRunning();
        this.uploadIconClass = (this.isAction('upload') || this.uploadActive) ? 'w-4 h-4 animate-spin' : 'w-4 h-4';
        this.uploadButtonLabel = this.uploadActive ? '백그라운드 실행 중' : (this.isAction('upload') ? '요청 중...' : '메모리 올리기');

        this.uploadStateText = this.uploadStateLabel();
        this.uploadStateBadgeClass = this.uploadStateClass();
        this.uploadHeaderIconClass = this.uploadActive ? 'w-4 h-4 text-blue-600 animate-pulse' : 'w-4 h-4 text-blue-600';
        this.uploadSourceText = this.uploadSourceLabel();
        this.uploadMessageText = this.uploadMessage || '메모리 상태를 확인 중입니다';
        this.uploadProgressWidth = this.uploadActive ? Math.max(this.uploadProgress(), 1) : this.uploadProgress();
        this.uploadProgressBarClass = this.uploadActive ? 'memory-upload-progress-active' : '';
        this.uploadProgressText = this.uploadProgressLabel();
        this.uploadElapsedText = this.formatDuration(this.uploadElapsedSeconds);
        this.uploadEstimatedText = this.formatDuration(this.uploadEstimatedSeconds);
        this.uploadRemainingText = this.formatDuration(this.uploadRemainingSeconds);
        this.uploadReadSizeText = this.formatSize(this.uploadReadBytes);
        this.uploadTotalSizeText = this.formatSize(this.uploadTotalBytes);
        this.uploadPidText = this.text(this.servicePid, this.uploadStateText);
        this.uploadRssText = this.formatSize(this.serviceMemory.rss || 0);
        this.uploadProgressPathText = this.text(this.uploadProgressPath);

        const diagnostics = this.serviceDiagnostics || {};
        this.diagnosticsVisible = this.showDiagnostics();
        this.diagnosticMessageText = this.diagnosticSummary();
        this.diagnosticHealthUrlText = this.text(diagnostics.health_url || this.serviceUrl);
        this.diagnosticPidFileText = this.text(diagnostics.pid_file);
        this.diagnosticPidSourceText = this.text(diagnostics.pid_source);
        this.diagnosticVersionText = `${this.text(diagnostics.actual_version)} / ${this.text(diagnostics.expected_version)}`;
        this.diagnosticScriptPathText = this.text(diagnostics.script_path || this.serviceScript);
        this.diagnosticIndexPathText = this.text(diagnostics.index_path || this.indexPath);

        this.serviceStateText = this.serviceStateLabel();
        this.serviceStateBadgeClass = this.serviceStateClass();
        this.servicePidText = this.text(this.servicePid);
        this.indexStateText = this.fileStateLabel(this.indexExists);
        this.indexStateBadgeClass = this.fileStateClass(this.indexExists);
        this.indexSizeText = this.formatSize(this.indexSize);
        this.indexModifiedText = this.formatDate(this.indexModifiedAt);
        this.nameIndexStateText = this.fileStateLabel(this.nameIndexExists);
        this.nameIndexStateBadgeClass = this.fileStateClass(this.nameIndexExists);
        this.nameIndexSizeText = this.formatSize(this.nameIndexSize);
        this.nameIndexModifiedText = this.formatDate(this.nameIndexModifiedAt);
        this.buildStateText = this.buildStateLabel();
        this.buildStateBadgeClass = this.buildStateClass();
        this.buildPidText = this.text(this.buildChildPid || this.buildPid);
        this.buildPhaseText = this.buildPhase();

        this.rebuildVisible = this.rebuildState !== 'idle' || !!this.rebuildStartedAt;
        this.rebuildStateText = this.rebuildStateLabel();
        this.rebuildStateBadgeClass = this.rebuildStateClass();
        this.rebuildPhaseText = this.rebuildPhaseLabel();
        this.rebuildProgressWidth = this.rebuildRunning
            ? Math.max(Number(this.rebuildProgressValue || 0), 1)
            : Number(this.rebuildProgressValue || 0);
        this.rebuildProgressText = this.rebuildProgressValue === null
            ? (this.rebuildRunning ? '진행 중' : '-')
            : this.formatPercent(this.rebuildProgressValue);
        this.rebuildProgressBarClass = this.rebuildRunning ? 'memory-upload-progress-active' : '';
        this.rebuildStartedText = this.formatDate(this.rebuildStartedAt);
        this.rebuildFinishedText = this.formatDate(this.rebuildFinishedAt);
        this.rebuildElapsedText = this.formatDuration(this.rebuildElapsedSeconds);
        this.rebuildEtaText = this.formatDuration(this.rebuildEtaSeconds);
        this.rebuildPidText = this.text(this.rebuildPid);
        this.rebuildVerificationText = this.rebuildVerified ? '검색 검증 통과' : (this.rebuildState === 'failed' ? '검증 실패' : '검증 대기');
        this.rebuildVerificationClass = this.rebuildVerified
            ? 'bg-emerald-50 text-emerald-700 border-emerald-100'
            : (this.rebuildState === 'failed' ? 'bg-red-50 text-red-600 border-red-100' : 'bg-gray-100 text-gray-600 border-gray-200');
        this.rebuildKeywordSizeText = this.formatSize(this.rebuildIndexes.keyword_index_bytes || 0);
        this.rebuildNameSizeText = this.formatSize(this.rebuildIndexes.name_index_bytes || 0);
        this.rebuildResearcherCountText = this.formatNumber(this.rebuildIndexes.researchers || 0);
        this.rebuildDocumentCountText = this.formatNumber(this.rebuildIndexes.documents || 0);
        this.rebuildTermCountText = this.formatNumber(this.rebuildIndexes.display_terms || 0);
        this.rebuildSchemaText = this.text(this.rebuildIndexes.schema);
        this.rebuildNameVerifyText = this.verificationText('researcher_name_query', 'researcher_name_rows');
        this.rebuildKeywordVerifyText = this.verificationText('keyword_query', 'keyword_rows');
        const expanded = Array.isArray(this.rebuildVerification.expanded_keywords)
            ? this.rebuildVerification.expanded_keywords.join(', ')
            : '';
        this.rebuildExpandedVerifyText = expanded
            ? `${expanded} · ${this.formatNumber(this.rebuildVerification.expanded_rows || 0)}건`
            : '-';

        this.systemMemoryPercentText = this.formatPercent(this.systemMemory.used_percent);
        this.systemMemoryUsedText = this.formatSize(this.systemMemory.used || 0);
        this.systemMemoryTotalText = this.formatSize(this.systemMemory.total || 0);
        this.systemMemoryAvailableText = this.formatSize(this.systemMemory.available || 0);
        this.systemMemoryBarClass = this.memoryBarClass(this.systemMemory.used_percent);
        this.systemMemoryBarWidth = this.memoryPercent(this.systemMemory.used_percent);
        this.serviceMemoryPidText = this.text(this.serviceMemory.pid);
        this.serviceMemoryRssText = this.formatSize(this.serviceMemory.rss || 0);
        this.serviceMemoryVmsText = this.formatSize(this.serviceMemory.vms || 0);
        this.serviceMemoryHwmText = this.formatSize(this.serviceMemory.hwm || 0);
        this.serviceMemoryPercentText = this.formatPercent(this.serviceMemory.rss_percent);
        this.serviceMemoryBarWidth = this.memoryPercent(this.serviceMemory.rss_percent);
        this.buildMemoryPidText = this.text(this.buildMemory.pid);
        this.buildMemoryRssText = this.formatSize(this.buildMemory.rss || 0);
        this.buildMemoryVmsText = this.formatSize(this.buildMemory.vms || 0);
        this.buildMemoryPercentText = this.formatPercent(this.buildMemory.rss_percent);
        this.buildMemoryBarWidth = this.memoryPercent(this.buildMemory.rss_percent);
        this.runtimeLimitText = this.text(this.runtimeLimitMode);

        this.serviceUrlText = this.text(this.serviceUrl);
        this.serviceScriptText = this.text(this.serviceScript);
        this.indexPathText = this.text(this.indexPath);
        this.nameIndexPathText = this.text(this.nameIndexPath);
        this.serviceInfoVisible = !!(this.serviceVersion || this.serviceLoadSeconds);
        this.serviceVersionText = this.text(this.serviceVersion);
        this.serviceLoadSecondsText = String(this.serviceLoadSeconds || 0);
        this.restartDisabled = !!this.action || this.isBuildRunning() || !this.indexExists;
        this.restartIconClass = this.isAction('restart') ? 'w-4 h-4 animate-spin' : 'w-4 h-4';
        this.stopDisabled = !!this.action || !this.serviceProcessRunning;
        this.hasLogLines = this.logLines.length > 0;
        this.hasNoLogLines = !this.hasLogLines;
    }

    private responseMessage(json: any, fallback: string) {
        const data = json && json.data ? json.data : {};
        return data.message || (json && json.message) || fallback;
    }

    private errorMessage(error: any, fallback: string) {
        return error && error.message ? error.message : fallback;
    }

    private normalizePercent(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const num = Number(value);
        return Number.isFinite(num) ? Math.max(0, Math.min(100, num)) : null;
    }

    public async loadStatus(render: boolean = true) {
        this.loading = render;
        if (render) {
            this.error = '';
            this.updateDisplayState();
            await this.service.render();
        }
        try {
            const json = await this.postForm('keyword_memory_status');
            const payload = this.statusPayload(json);
            if (json && json.code === 200 && payload) {
                this.applyStatus(payload);
            } else {
                this.error = this.responseMessage(json, '메모리 상태를 불러오지 못했습니다.');
            }
        } catch (e) {
            this.error = this.errorMessage(e, '메모리 상태를 불러오지 못했습니다.');
        }
        this.loading = false;
        this.updateDisplayState();
        await this.service.render();
    }

    private async runAction(action: string, fn: string, params: Record<string, any> = {}, success: string = '') {
        if (this.action) return;
        this.action = action;
        this.error = '';
        this.message = '';
        this.updateDisplayState();
        await this.service.render();
        try {
            const json = await this.postForm(fn, params);
            const payload = this.statusPayload(json);
            if (payload) {
                this.applyStatus(payload);
            }
            this.message = success || this.responseMessage(json, '요청을 처리했습니다.');
        } catch (e) {
            this.error = this.errorMessage(e, '요청 처리에 실패했습니다.');
        }
        this.action = '';
        this.updateDisplayState();
        await this.service.render();
    }

    public async uploadMemory() {
        await this.runAction('upload', 'keyword_memory_upload', {}, '백그라운드 메모리 올리기를 시작했습니다. 진행 상태는 자동 갱신됩니다.');
    }

    public async restartService() {
        await this.runAction('restart', 'keyword_memory_restart', {}, '메모리 서비스를 재시작했습니다.');
    }

    public async stopService() {
        await this.runAction('stop', 'keyword_memory_stop', {}, '메모리 서비스를 중지했습니다.');
    }

    public openRebuildConfirm() {
        if (this.action || this.isBuildRunning()) return;
        this.showRebuildConfirm = true;
        this.error = '';
        this.message = '';
        this.service.render();
    }

    public closeRebuildConfirm() {
        if (this.action === 'build') return;
        this.showRebuildConfirm = false;
        this.service.render();
    }

    public async rebuildIndex() {
        this.showRebuildConfirm = false;
        await this.runAction('build', 'keyword_memory_build', {
            force_full: 'true',
            load_after_build: 'true',
        }, '전체 인덱스 생성을 시작했습니다.');
    }

    public async stopBuild() {
        await this.runAction('stop-build', 'keyword_memory_build_stop', {}, '인덱스 생성 작업을 중지했습니다.');
    }

    public toggleAutoRefresh() {
        this.autoRefreshEnabled = !this.autoRefreshEnabled;
        if (this.autoRefreshEnabled) {
            this.loadStatus(false);
        }
        this.updateDisplayState();
        this.service.render();
    }

    public isAction(name: string) {
        return this.action === name;
    }

    public isBuildRunning() {
        return this.rebuildRunning || this.buildRunning || this.buildState === 'running';
    }

    public shouldAutoRefresh() {
        return this.autoRefreshEnabled;
    }

    public serviceStateLabel() {
        const labels: any = {
            ready: '준비됨',
            loading: '로딩 중',
            missing_index: '인덱스 없음',
            version_mismatch: '버전 불일치',
            stopped: '중지됨',
            unknown: '확인 필요',
        };
        return labels[this.serviceState] || this.serviceState;
    }

    public serviceStateClass() {
        const state = this.serviceState || '';
        if (state === 'ready') return 'bg-emerald-50 text-emerald-700 border-emerald-100';
        if (state === 'loading') return 'bg-amber-50 text-amber-700 border-amber-100';
        if (state === 'version_mismatch') return 'bg-amber-50 text-amber-700 border-amber-100';
        if (state === 'missing_index') return 'bg-red-50 text-red-600 border-red-100';
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }

    public uploadStateLabel() {
        const labels: any = {
            starting: '시작 중',
            loading: '올리는 중',
            completed: '완료',
            failed: '실패',
            missing_index: '인덱스 없음',
            version_mismatch: '버전 불일치',
            stopped: '중지됨',
            ready: '완료',
            unknown: '확인 필요',
        };
        return labels[this.uploadState] || this.uploadState || '-';
    }

    public uploadStateClass() {
        const state = this.uploadState || '';
        if (state === 'completed' || state === 'ready') return 'bg-emerald-50 text-emerald-700 border-emerald-100';
        if (state === 'loading' || state === 'starting') return 'bg-[#EEF2FF] text-[#3D5DB8] border-[#4A6FD8]/20';
        if (state === 'version_mismatch') return 'bg-amber-50 text-amber-700 border-amber-100';
        if (state === 'failed' || state === 'missing_index') return 'bg-red-50 text-red-600 border-red-100';
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }

    public showUploadPanel() {
        return true;
    }

    public uploadProgress() {
        if (this.uploadProgressValue !== null) return this.uploadProgressValue;
        if (this.uploadState === 'completed' || this.uploadState === 'ready') return 100;
        return 0;
    }

    public uploadProgressLabel() {
        if (this.uploadProgressValue === null) {
            return this.uploadActive ? '확인 중' : '-';
        }
        return this.formatPercent(this.uploadProgressValue);
    }

    public uploadSourceLabel() {
        const labels: any = {
            health: '파일 읽기 기준',
            progress_file: '진행 파일 기준',
            process: '프로세스 기준',
        };
        return labels[this.uploadProgressSource] || this.uploadProgressSource || '-';
    }

    public showDiagnostics() {
        const d = this.serviceDiagnostics || {};
        return !!(
            this.serviceState !== 'ready'
            || d.health_error
            || d.health_error_type
            || d.version_match === false
            || d.pid_source === 'process_scan'
            || d.recovered_pid_file
            || d.script_exists === false
            || d.index_exists === false
        );
    }

    public diagnosticSummary() {
        const d = this.serviceDiagnostics || {};
        if (d.index_exists === false) return '인덱스 파일을 찾지 못했습니다.';
        if (d.script_exists === false) return '메모리 서비스 스크립트 경로를 찾지 못했습니다.';
        if (d.version_match === false && d.actual_version) return `실행 중인 서비스 버전(${d.actual_version})이 현재 버전(${d.expected_version})과 다릅니다.`;
        if (d.pid_source === 'process_scan') return 'PID 파일이 없어 실행 프로세스를 스캔해 복구했습니다.';
        if (this.serviceState === 'loading') return '서비스 프로세스는 실행 중이며 인덱스를 메모리에 올리는 중입니다.';
        if (d.health_error) return `헬스체크 실패: ${d.health_error}`;
        return '상태 확인이 필요합니다.';
    }

    private verificationText(queryKey: string, countKey: string) {
        const query = this.text(this.rebuildVerification[queryKey], '');
        if (!query) return '-';
        return `${query} · ${this.formatNumber(this.rebuildVerification[countKey] || 0)}건`;
    }

    public rebuildStateLabel() {
        const labels: any = {
            idle: '이력 없음',
            running: '재생성 중',
            completed: '완료',
            failed: '실패',
            stopped: '중지됨',
        };
        return labels[this.rebuildState] || this.rebuildState;
    }

    public rebuildStateClass() {
        if (this.rebuildState === 'completed' && this.rebuildVerified) return 'bg-emerald-50 text-emerald-700 border-emerald-100';
        if (this.rebuildState === 'running') return 'bg-blue-50 text-blue-700 border-blue-100';
        if (this.rebuildState === 'failed' || this.rebuildState === 'stopped') return 'bg-red-50 text-red-600 border-red-100';
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }

    public rebuildPhaseLabel() {
        const labels: any = {
            starting: '작업 시작',
            stopping: '기존 서비스 중지',
            resetting: '기존 인덱스·캐시 삭제',
            preflight: '서버 자원 점검',
            building_keyword: '전체 키워드 인덱스 생성',
            building_name: '연구자명 인덱스 생성',
            loading: '서버 메모리 로딩',
            verifying: '연구자명·RNA·확장검색 검증',
            completed: '재생성·로딩·검증 완료',
            failed: '작업 실패',
        };
        return labels[this.rebuildPhase] || this.rebuildPhase || '-';
    }

    public buildStateLabel() {
        const labels: any = {
            idle: '대기',
            running: '생성 중',
            loading: '메모리 로딩 중',
            completed: '완료',
            failed: '실패',
            stopped: '중지됨',
        };
        return labels[this.buildState] || this.buildState;
    }

    public buildStateClass() {
        const state = this.buildState || '';
        if (state === 'completed') return 'bg-emerald-50 text-emerald-700 border-emerald-100';
        if (state === 'running' || state === 'loading') return 'bg-amber-50 text-amber-700 border-amber-100';
        if (state === 'failed' || state === 'stopped') return 'bg-red-50 text-red-600 border-red-100';
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }

    public fileStateLabel(exists: boolean) {
        return exists ? '있음' : '없음';
    }

    public fileStateClass(exists: boolean) {
        return exists ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-red-50 text-red-600 border-red-100';
    }

    public buildPercent() {
        return this.buildPercentValue;
    }

    public buildPhase() {
        if (this.buildCurrentCommand && this.buildLastPhase) return `${this.buildCurrentCommand} / ${this.buildLastPhase}`;
        return this.buildCurrentCommand || this.buildLastPhase || '-';
    }

    public formatDuration(value: any) {
        const seconds = Math.max(0, Math.round(Number(value || 0)));
        if (!Number.isFinite(seconds) || seconds <= 0) return '-';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remain = seconds % 60;
        if (hours > 0) return `${hours}시간 ${minutes}분`;
        if (minutes > 0) return `${minutes}분 ${remain}초`;
        return `${remain}초`;
    }

    public formatNumber(value: any) {
        const num = Number(value || 0);
        return Number.isFinite(num) ? num.toLocaleString('ko-KR') : '0';
    }

    public formatSize(value: any) {
        const size = Number(value || 0);
        if (!Number.isFinite(size) || size <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let current = size;
        let unit = 0;
        while (current >= 1024 && unit < units.length - 1) {
            current = current / 1024;
            unit += 1;
        }
        const fixed = unit === 0 ? 0 : current >= 10 ? 1 : 2;
        return `${current.toFixed(fixed)} ${units[unit]}`;
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString('ko-KR', { hour12: false });
    }

    public formatPercent(value: any) {
        const percent = this.normalizePercent(value);
        if (percent === null) return '0%';
        return `${percent.toFixed(percent >= 10 ? 1 : 2)}%`;
    }

    public memoryPercent(value: any) {
        const percent = this.normalizePercent(value);
        return percent === null ? 0 : percent;
    }

    public memoryBarClass(value: any) {
        const percent = this.memoryPercent(value);
        if (percent >= 90) return 'bg-red-500';
        if (percent >= 75) return 'bg-amber-500';
        return 'bg-[#4A6FD8]';
    }
}

export default PortalAdminMemoryComponent;